module.exports = __webpack_public_path__ + "img/payment_success_man.1ca0812e.jpeg";